import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { useQuery } from '@apollo/client';
import { BsBookmarkStarFill, BsBookmarkStar } from 'react-icons/bs';
import { getItemList } from '../../../application/query';
import { useItemListId } from '../hooks';
import { getItemListData } from '../helpers';
const ItemListCounter = ({
  listName,
  modifier,
  url
}) => {
  const router = useRouter();
  const {
    listId
  } = useItemListId({
    listName
  });
  const {
    data,
    error,
    loading
  } = useQuery(getItemList, {
    variables: {
      id: listId
    },
    skip: !listId
  });
  if (loading) return '';
  if (error) return error.message;
  const listItems = getItemListData(data);
  const listLength = listItems.length;
  const CounterIcon = listLength ? BsBookmarkStarFill : BsBookmarkStar;
  const handleClick = () => router.push('/Resolver', `${url}?itemListId=${listId}`);
  return /*#__PURE__*/React.createElement("div", {
    role: "button",
    type: "button",
    className: `item-list-counter ${modifier}`,
    "aria-label": `View ${listName}`,
    onClick: handleClick
  }, /*#__PURE__*/React.createElement(CounterIcon, null), /*#__PURE__*/React.createElement("span", {
    className: "item-list-counter__badge"
  }, listLength));
};
ItemListCounter.propTypes = {
  url: PropTypes.string,
  listName: PropTypes.string,
  modifier: PropTypes.string
};
ItemListCounter.defaultProps = {
  url: '',
  listName: '',
  modifier: ''
};
export default ItemListCounter;
//# sourceMappingURL=ItemListCounter.js.map